import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    descuentos: [],
  },
  mutations: {

    getTarifas(state, datos) {
      state.descuentos = datos;
    },
    
    destroyDescuentos(state) {
      state.descuentos = [];
    },
  },
  actions: {
    async getTarifas({
      commit,
    }) {
      try {
        const res = await api.getTarifas();
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getTarifas', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async destroyDescuentos({ commit }) {
      commit('destroyDescuentos');
    },

    async insertTarifas({ }, tar) {
      try {
        const res = await api.insertTarifas(tar);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async deleteTarifas({ commit }, desc) {
      try {
        const res = await api.deleteTarifas(desc);
        // commit('deleteSucursales', res.data.sucursal);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async editTarifas({ }, tar) {
      try {
        const res = await api.editTarifas(tar);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

  },
};
